// Styles for UtilityLinks go here.
import styled from 'styled-components';
import { baseVariables, toRem, contextualVariable } from '@marriott/mi-ui-library';

export const StyledNavigationUtilityLink = styled.ul<{ isRenderedInsideOverLay: boolean; isBrandedVariation: boolean }>`
  display: flex;
  padding: 0;
  margin: 0;

  .brand-logo-marriott-bonvoy-wordmark {
    font-size: ${toRem(8)} !important;
    line-height: ${toRem(7.38)} !important;
    font-weight: 400 !important;
    max-width: ${toRem(108)} !important;
    color: ${contextualVariable.brandedFontColor};
  }
  @media ${baseVariables.mediaQuery.md} {
    .brand-logo-marriott-bonvoy-wordmark {
      font-size: ${toRem(12)} !important;
      line-height: ${toRem(10.336)} !important;
      max-width: ${toRem(161)} !important;
    }
  }

  ${({ isRenderedInsideOverLay }) =>
    isRenderedInsideOverLay
      ? `
        flex-direction: column;
        gap: ${toRem(24)};
        `
      : `
        align-items: center;
        gap: ${toRem(16)};
      `}

  @media ${baseVariables.mediaQuery.md} {
    .color-scheme7 {
      .utility-icon {
        &::before {
          color: var(--t-interactive-accent-color);
        }
      }
    }
  }

  .utility {
    &-datapagecomponent {
      list-style-type: none;
      margin-left: ${toRem(-16)};
    }
    &-item {
      list-style-type: none;
      white-space: nowrap;
      color: inherit;
      padding: 0;
      > a {
        color: inherit;
      }
      > [class*='utility-'] {
        ::before {
          height: ${toRem(24)};
          width: ${toRem(24)};
          padding: ${toRem(4)};
        }
      }
    }

    &-language-selector {
      :focus {
        outline: 1px dotted #212121;
        outline: 5px auto -webkit-focus-ring-color;
      }
      @media ${baseVariables.mediaQuery.md} {
        order: 0;
      }
    }

    &-trips {
      :focus {
        outline: 1px dotted #212121;
        outline: 5px auto -webkit-focus-ring-color;
      }
    }

    &-home {
      .utility-icon {
        ::before {
          height: ${toRem(32)};
          width: ${toRem(32)};
          padding: ${toRem(4)};
        }
        @media ${baseVariables.mediaQuery.md} {
          ::before {
            height: ${toRem(24)};
            width: ${toRem(24)};
            padding: ${toRem(4)};
          }
        }
      }
    }

    &-link-text {
      color: inherit;
      font-weight: ${baseVariables.font.fontWeightRegular};
      line-height: ${toRem(15)};
      margin-left: 0;
      font-size: ${baseVariables.font.fontXs};
      @media ${baseVariables.mediaQuery.xl} {
        line-height: ${baseVariables.font.lineHeightS};
      }
    }

    &-icon {
      display: flex;
      align-items: center;
      font-size: ${({ isRenderedInsideOverLay }) =>
        isRenderedInsideOverLay ? baseVariables.font.fontM : baseVariables.font.fontXxxl};
      font-weight: 400;
      color: inherit;

      ::before {
        display: flex;
        align-items: center;
        padding: ${toRem(4)};
        height: ${toRem(32)};
        width: ${toRem(32)};
      }

      @media ${baseVariables.mediaQuery.md} {
        font-size: ${baseVariables.font.fontM};
        ::before {
          height: ${toRem(24)};
          width: ${toRem(24)};
          padding: ${toRem(4)};
        }
      }
    }

    &-mytrips-button,
    &-language-selector-button {
      display: flex;
      align-items: center;
      color: inherit;
      background: transparent;
      padding: 0;
      :focus {
        outline: 1px dotted #212121;
        outline: 5px auto -webkit-focus-ring-color;
      }
    }
    &-sigin {
      .utility-link-text {
        margin-left: ${toRem(4)};
      }

      @media ${({ isBrandedVariation }) =>
          isBrandedVariation ? baseVariables.mediaQuery.md : baseVariables.mediaQuery.lg} {
        order: 2;
        .utility-link-text {
          font-size: 13px;
          line-height: 13px;
        }
        .utility-icon {
          font-size: ${baseVariables.font.fontM};
          &::before {
            height: ${toRem(16)};
            width: ${toRem(16)};
            padding: ${toRem(0)};
            background-color: transparent;
          }
        }
      }
    }
    &-link-selector {
      @media ${baseVariables.mediaQuery.md} {
        order: 0;
      }
    }

    &-trips-signed-in {
      @media ${baseVariables.mediaQuery.md} {
        order: 3;
      }
    }
    &-trips-sign-in {
      @media ${baseVariables.mediaQuery.md} {
        order: 1;
      }
    }

    &-home {
      @media ${baseVariables.mediaQuery.md} {
        order: 2;
      }
    }

    &-signed-in {
      @media ${baseVariables.mediaQuery.md} {
        order: 4;
      }
    }
  }

  .utility-logo-sign-in {
    @media ${baseVariables.mediaQuery.md} {
      order: 3;
    }
  }
`;
